import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
} from "@angular/core";

@Component({
  standalone: false,
  selector: 'app-recipient-selector',
  templateUrl: './recipient-selector.component.html',
  styleUrls: ['./recipient-selector.component.css']
})
export class RecipientSelectorComponent implements OnChanges {
  @Input() users: any[] = [];
  @Input() selectedUsers: any[] = [];
  @Output() selectionChange = new EventEmitter<any[]>();

  searchQuery: string = "";
  isSearchFocused = false;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["selectedUsers"]) {
      this.selectedUsers = Array.isArray(this.selectedUsers)
        ? [...this.selectedUsers]
        : [];
    }
  }

  get filteredUsers(): any[] {
    const query = this.searchQuery.trim().toLowerCase();
    if (!query) return this.isSearchFocused ? this.users : [];
    return this.users.filter((user) =>
      (user?.name || "").toLowerCase().includes(query)
    );
  }

  handleSearchFocus(): void {
    this.isSearchFocused = true;
  }

  handleSearchBlur(): void {
    this.isSearchFocused = false;
  }

  isSelected(user: any): boolean {
    const userKey = this.getUserKey(user);
    return this.selectedUsers.some((u) => this.getUserKey(u) === userKey);
  }

  toggleUser(user: any): void {
    if (this.isSelected(user)) {
      const userKey = this.getUserKey(user);
      this.selectedUsers = this.selectedUsers.filter(
        (u) => this.getUserKey(u) !== userKey,
      );
    } else {
      this.selectedUsers = [...this.selectedUsers, user];
    }
    this.selectionChange.emit(this.selectedUsers);
  }

  removeUser(user: any): void {
    const userKey = this.getUserKey(user);
    this.selectedUsers = this.selectedUsers.filter(
      (u) => this.getUserKey(u) !== userKey,
    );
    this.selectionChange.emit(this.selectedUsers);
  }

  private getUserKey(user: any): string {
    return String(user?.userSubjectId || user?.subjectId || user?.id || user?.userId || "");
  }
}
